import {
  Box,
  Button,
  Divider,
  Flex,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from '@chakra-ui/react';

const QuizCardOptions = ({
  question,
  answer,
  userResponses,
  handleSaveResponse,
}) => {
  const handleSelection = e => {
    handleSaveResponse(prev => {
      return {
        ...prev,
        [question.key]: e,
      };
    });
  };

  return (
    <RadioGroup
      isDisabled={answer != null}
      onChange={handleSelection}
      value={userResponses[question?.key]}
    >
      <Stack spacing={5} direction="column">
        {question?.options &&
          Object.keys(question.options).length > 0 &&
          Object.keys(question.options).map(optionKey => {
            // let answer = undefined;
            const isCorrectAnswer = answer?.options?.includes(optionKey);
            const isUserAnswer = userResponses[question.key] === optionKey;

            const checkboxStyle = {
              background: isCorrectAnswer
                ? '#49C78E'
                : isCorrectAnswer === false && isUserAnswer
                ? '#EC7171'
                : isUserAnswer
                ? '#7F56D9'
                : null,
              borderColor: isCorrectAnswer
                ? '#49C78E'
                : isCorrectAnswer === false && isUserAnswer
                ? '#EC7171'
                : isUserAnswer
                ? '#7F56D9'
                : null,
            };

            return (
              <Box
                maxWidth="fit-content"
                p="5px"
                border="1px solid #D0D5DD"
                boxShadow="0px 0px 0px 4px #F2F4F7 ; 0px 1px 2px 0px #1018280D"
                color="#344054"
                // background={answer?.includes(optionKey) ? '#49C78E' : 'white'}
                // bg={
                //   isCorrectAnswer
                //     ? '#49C78E'
                //     : isUserAnswer
                //     ? '#7F56D9'
                //     : 'white'
                // }
              >
                <Radio
                  value={optionKey}
                  //   _checked={{ bg: '#7F56D9', borderColor: '#7F56D9' }}
                  _checked={checkboxStyle}
                  style={checkboxStyle}
                  //   backgroundColor="#7F56D9"
                  _before={{ width: '0 !important' }}
                >
                  {question.options[optionKey].optionText}
                </Radio>
              </Box>
            );
          })}
        {/* <Box
            maxWidth="fit-content"
            p="5px"
            border="1px solid #D0D5DD"
            boxShadow="0px 0px 0px 4px #F2F4F7 ; 0px 1px 2px 0px #1018280D"
            color="#344054"
          >
            <Radio
              value="1"
              _checked={{ bg: '#7F56D9', borderColor: '#7F56D9' }}
              //   backgroundColor="#7F56D9"
              _before={{ width: '0 !important' }}
            >
              Option 1 feffffffffffffffffffffffffffffffffffffffffffff
            </Radio>
          </Box> */}
      </Stack>
    </RadioGroup>
  );
};

const QuizExplainationCard = ({ explanation }) => {
  return (
    <Box p={6} color="#1B2559" width="100%">
      <Text fontSize="1.4rem">Explaination :</Text>
      <Text fontSize="1rem" fontWeight="400">
        {explanation}
      </Text>
    </Box>
  );
};

const QuizCardBody = ({
  question,
  answer,
  handleQuestionIndex,
  totalQuestions,
  currentIndex,
  userResponses,
  handleSaveResponse,
}) => {
  return (
    <Flex direction="column" justifyContent="center" alignItems="center">
      <Box
        border="3px dashed #4318FF"
        minH="400px"
        minW="80%"
        borderRadius="20px"
        p="16px"
      >
        {/* Question Div*/}
        <Flex justifyContent="space-between">
          <Text fontSize="1.2rem" fontWeight="700" color="#1B2559">
            {question?.questionText ?? ''}
          </Text>
          <Text fontSize="0.9rem" color="#718096" fontWeight="500">
            {currentIndex + 1}/{totalQuestions}
          </Text>
        </Flex>

        <Divider my="10px" borderColor="#D3D4D7" />

        {/* Answer Div*/}
        <Box>
          <QuizCardOptions
            question={question}
            answer={answer}
            userResponses={userResponses}
            handleSaveResponse={handleSaveResponse}
          />
          {/* <Textarea placeholder="Type your answer here" height="300px" /> */}
        </Box>
      </Box>
      {answer && answer.explanation ? (
        <QuizExplainationCard explanation={answer.explanation} />
      ) : (
        <Flex width="250px" justifyContent="space-between" mt="2">
          <Button
            w="110px"
            bg="linear-gradient(15.46deg, #4A25E1 26.3%, #7B5AFF 86.4%)"
            _hover={{
              background:
                'linear-gradient(15.46deg, #183f73 26.3%, #7B5AFF 86.4%)',
            }}
            color="white"
            onClick={() => handleQuestionIndex('prev')}
          >
            Prev
          </Button>
          <Button
            w="110px"
            bg="linear-gradient(15.46deg, #4A25E1 26.3%, #7B5AFF 86.4%)"
            _hover={{
              background:
                'linear-gradient(15.46deg, #183f73 26.3%, #7B5AFF 86.4%)',
            }}
            color="white"
            onClick={() => handleQuestionIndex('next')}
          >
            {currentIndex === totalQuestions - 1 ? 'Submit' : 'Next'}
          </Button>
        </Flex>
      )}
      {/* <QuizExplainationCard /> */}
    </Flex>
  );
};

export default QuizCardBody;
